// extracted by mini-css-extract-plugin
export default {"r_l":"_5e82ef3aa2 _9d47fa08fc","t":"_57e2d93ae5"};